import HomePageContent from 'components/HomePageContent/HomePageContent';

const HomePage = () => {
  return <HomePageContent />;
};

export default HomePage;
